import gql from "graphql-tag";

export const customerApplicationsQuery = gql`
  query customerApplications(
    $orderBy: OrderBy
    $filters: CustomerApplicationsFilters
    $page: Int
    $perPage: Int
  ) {
    customerApplications(orderBy: $orderBy, filters: $filters, page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        companyName
        companyCode
        companyType
        taxNumber
        comment
        status
        createdAt
        region {
          id
          name
        }
        manager {
          id
          name
        }
        user {
          id
          firstName
          lastName
          phone
          email
          roles {
            name
          }
        }
      }
    }
  }
`;

export const customerApplicationLogsQuery = gql`
  query customerApplicationLogs($customerApplicationId: ID!, $page: Int, $perPage: Int) {
    customerApplicationLogs(
      customerApplicationId: $customerApplicationId
      page: $page
      first: $perPage
    ) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        eventTypeLabel
        comment
        statusAtEvent
        userFullName
        userEmail
        createdAt
      }
    }
  }
`;

export const customerApplicationCommentsQuery = gql`
  query customerApplicationComments($customerApplicationId: ID!, $page: Int, $perPage: Int) {
    customerApplicationComments(
      customerApplicationId: $customerApplicationId
      page: $page
      first: $perPage
    ) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        body
        statusAtEvent
        userFullName
        userEmail
        createdAt
      }
    }
  }
`;
